function SvgHouse2(props, { color = "#FFA600", width = 20, height = 20 }) {
  const { color: iconColor, ...restProps } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <path
        d="M1.66797 18.334H18.3346"
        stroke={iconColor || color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.45703 18.3324L2.4987 8.30739C2.4987 7.79905 2.74036 7.31577 3.14036 6.9991L8.9737 2.45742C9.5737 1.99076 10.4154 1.99076 11.0237 2.45742L16.857 6.99076C17.2654 7.30742 17.4987 7.79072 17.4987 8.30739V18.3324"
        stroke={iconColor || color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M12.9154 9.16602H7.08203C6.39036 9.16602 5.83203 9.72435 5.83203 10.416V18.3327H14.1654V10.416C14.1654 9.72435 13.607 9.16602 12.9154 9.16602Z"
        stroke={iconColor || color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33203 13.541V14.791"
        stroke={iconColor || color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.75 6.25H11.25"
        stroke={iconColor || color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SvgHouse2;
